import { useState } from 'react'
import { FiX } from 'react-icons/fi'
import Button from '../ui/Button'
import { Input } from '../ui/shadcn/input'
import { Checkbox } from '../ui/shadcn/checkbox'

export default function FolderEditorModal({ onClose, folder, title }) {
    const [name, setName] = useState(folder?.name || '')
    const [visibility, setVisibility] = useState(folder?.visibility || 'private')

    const isPrivate = visibility === 'private'

    const handleSave = () => {
        if (!name.trim()) return
        onClose({ name: name.trim(), visibility })
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') handleSave()
    }

    return (
        <div className='w-full max-w-[420px] rounded-md flex flex-col bg-background border'>
            <div className='flex justify-between py-2 px-4 border-b items-center'>
                <span className='text-lg font-bold'>{title || (folder ? 'Edit Folder' : 'New Folder')}</span>
                <div className='cursor-pointer text-gray-400 hover:text-white' onClick={() => onClose(null)}>
                    <FiX className='w-5 h-5' />
                </div>
            </div>
            <div className='flex flex-col gap-4 p-4'>
                <div className='flex flex-col gap-1'>
                    <label className='text-xs text-secondary-foreground'>Name</label>
                    <Input
                        type='text'
                        placeholder='Folder name'
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        onKeyDown={handleKeyDown}
                        autoFocus
                    />
                </div>
                <div className='flex items-center gap-2'>
                    <Checkbox
                        id='folder-private'
                        checked={isPrivate}
                        onCheckedChange={(checked) => setVisibility(checked ? 'private' : 'public')}
                    />
                    <label htmlFor='folder-private' className='text-xs text-secondary-foreground select-none cursor-pointer'>
                        Private (only you can see this folder)
                    </label>
                </div>
            </div>
            <div className='flex justify-between p-2'>
                <Button type='danger-ghost' className='min-w-20' onClick={() => onClose(null)}>Cancel</Button>
                <Button type='primary' className='min-w-20' onClick={handleSave} disabled={!name.trim()}>Save</Button>
            </div>
        </div>
    )
}
